import { merge, uniqBy } from 'lodash'
import requestShowInitialState from './state'
import helpers from '../../../utils/helpers.js'

export default {
  reinitializeState: (state) => {
    if (state.jobPollIntervalId) {
      clearInterval(state.jobPollIntervalId)
    }
    if (state.timelineFallbackTimerId) {
      clearTimeout(state.timelineFallbackTimerId)
    }
    Object.assign(state, requestShowInitialState)
  },
  setTimelineFallbackTimerId: (state, val) => {
    if (
      state.timelineFallbackTimerId &&
      state.timelineFallbackTimerId !== val
    ) {
      clearTimeout(state.timelineFallbackTimerId)
    }
    state.timelineFallbackTimerId = val
  },
  setRequest: (state, val) => {
    state.request = val
  },
  setDocuments: (state, val) => {
    state.documents = val
  },
  setRequestStaff: (state, val) => {
    const index = state.requestStaff.findIndex((staff) => +staff.id === +val.id)
    if (index !== -1) {
      state.requestStaff.splice(index, 1, val)
    } else {
      state.requestStaff = val
    }
  },
  setRequestTags: (state, val) => {
    state.requestTags = val
  },
  setRequestTasks: (state, val) => {
    state.requestTasks = val
  },
  setCurrentRequestTasksCount: (state, val) => {
    state.currentRequestTasksCount = val
  },
  setTotalRequestTasksCount: (state, val) => {
    state.totalRequestTasksCount = val
  },
  setTask: (state, val) => {
    const index = state.requestTasks.findIndex((task) => +task.id === +val.id)
    if (index !== -1) {
      state.requestTasks.splice(index, 1, val)
    } else {
      state.requestTasks = [...state.requestTasks, val]
    }
  },
  setTotalRequestTimelineCount: (state, val) => {
    state.totalRequestTimelineCount = val
  },
  setRequestTimeline: (state, val) => {
    state.requestTimeline = val
  },
  setSelectedTimelineEvent: (state, val) => {
    state.selectedTimelineEvent = val
  },
  setRequestInvoice: (state, val) => {
    const index = state.requestInvoices.findIndex(
      (invoice) => +invoice.id === +val.id
    )
    if (index !== -1) {
      state.requestInvoices.splice(index, 1, val)
    } else {
      state.requestInvoices = [...state.requestInvoices, val]
    }
  },
  setRequestInvoices: (state, val) => {
    state.requestInvoices = val
  },
  setRequestStaffHours: (state, val) => {
    state.requestStaffHours = val
  },
  setRequestStaffCostUnpaid: (state, val) => {
    state.requestStaffCostUnpaid = val
  },
  setDocumentsFolders: (state, val) => {
    state.documentsFolders = val
  },
  setTotalDocumentsFoldersCount: (state, val) => {
    state.totalDocumentsFoldersCount = val
  },
  setDocumentsChildFolders: (state, val) => {
    state.documentsFolders = [...new Set(val)]
  },
  setAllDocumentsCount: (state, val) => {
    state.allDocumentsCount = val
  },
  setNoFolderDocumentsCount: (state, val) => {
    state.noFolderDocumentsCount = val
  },
  setSearchDocumentResultsCount: (state, val) => {
    state.searchDocumentResultsCount = val
  },
  setCurrentDocumentsCount: (state, val) => {
    state.currentDocumentsCount = val
  },
  setDocumentsStateTimestamp: (state, val) => {
    state.documentsStateTimestamp = val
  },
  setTotalDocumentsCount: (state, val) => {
    state.totalDocumentsCount = val
  },
  setDocumentFilters: (state, val) => {
    state.currentDocumentFilters = val
  },
  setInvoiceTemplates: (state, val) => {
    state.invoiceTemplates = val
  },
  setSelectedChangeDocVisibility: (state, val) => {
    state.selectedChangeDocVisibility = val
  },
  setPreviewRequestPage: (state, val) => {
    state.previewRequestPage = val
  },
  setMessageToRequester: (state, val) => {
    state.messageToRequester = val
  },
  setDocument: (state, val) => {
    const index = state.documents.findIndex((i) => i.id === val.id)
    if (index === -1) return
    Object.assign(state.documents[index], val)
  },
  setActiveModal: (state, val) => {
    state.activeModal = val
  },
  setDisplayInternalMsgBox: (state, val) => {
    state.displayInternalMsgBox = val
  },
  setDisplayCreateInvoiceMsgBox: (state, val) => {
    state.displayCreateInvoiceMsgBox = val
  },
  setDisplayExternalMsgBox: (state, val) => {
    state.displayExternalMsgBox = val
  },
  setDisplayCreateStaffTimeBox: (state, val) => {
    state.displayStaffTimeBox = val
  },
  setDisplayCreateTaskMsgBox: (state, val) => {
    state.displayCreateTaskMsgBox = val
  },
  setDisplayMsgBox: (state, val) => {
    state.displayMsgBox = val
  },
  setDisplayEditRequestTextBox: (state, val) => {
    state.displayEditRequestTextBox = val
  },
  setCurrentAction: (state, val) => {
    state.currentAction = val
  },
  setEditingTask: (state, val) => {
    state.editingTask = val
  },
  setDocumentsProcessingIds: (state, val) => {
    state.documentsProcessingIds = val
  },
  setRequestDocumentRisk: (state, val) => {
    state.requestDocumentRisk = val
  },
  setStatus(state, value) {
    state.request = Object.assign({}, state.request, {
      request_state: value
    })
  },
  setClosureTemplates(state, val) {
    state.closureTemplates = uniqBy(val, 'id')
  },
  setDataFetchState(state, val) {
    state.dataFetchState = merge({}, state.dataFetchState, val)
  },
  setDataOptions(state, opts) {
    Object.keys(opts).forEach((key) => {
      if (opts[key].length) {
        state.dataOptions[key] = uniqBy(
          [...state.dataOptions[key], ...opts[key]],
          'id'
        )
      } else {
        state.dataOptions[key] = []
      }
    })
  },
  setFilteredRequestLoading(state, val) {
    state.filteredRequestLoading = val
  },
  setPinnedNote(state, val) {
    state.pinnedNote = val
  },
  setJobPollIntervalId(state, val) {
    if (state.jobPollIntervalId && state.jobPollIntervalId !== val) {
      clearInterval(state.jobPollIntervalId)
    }
    state.jobPollIntervalId = val
  },
  setActiveInvoiceLineItem(state, val) {
    state.invoiceLineItemForm = val
  },
  setInvoiceSelectedLineItem(state, val) {
    state.invoiceLineItemForm.selectedLineItem = val
  },
  setInvoiceLineItemQuantity(state, val) {
    state.invoiceLineItemForm.lineItemQuantity = val
  },
  setInvoiceLineItemType(state, val) {
    state.invoiceLineItemType = val
  },
  setInvoiceSelectedSurchargeItem(state, val) {
    state.invoiceSelectedSurchargeItem = val
  },
  setInvoiceAddItemModal(state, val) {
    state.activeAddItemModal = val
  },
  setTotalSelectedLineItems(state, val) {
    state.totalSelectedLineItems = val
  },
  setTotalSelectedSurchargeItems(state, val) {
    state.totalSelectedSurchargeItems = val
  },
  setSubtotalInvoiceAmount(state, val) {
    const amount = helpers.roundInvoiceAmount(val)
    state.subtotalInvoiceAmount = amount
  },
  setTotalInvoiceAmount(state, val) {
    const amount = helpers.roundInvoiceAmount(val)
    state.totalInvoiceAmount = amount
  },
  setInvoiceItemToEdit(state, val) {
    state.invoiceItemToEdit = val
  },
  setSelectedStaffHour(state, val) {
    state.selectedStaffHour = val
  },
  setFieldValue: (state, val) => {
    if (Array.isArray(state.request.field_values)) {
      const index = state.request.field_values.findIndex(
        (field) => field.id === val.id
      )
      if (index !== -1) {
        state.request.field_values.splice(index, 1, val)
      }
    }
  },
  addFieldValue: (state, val) => {
    if (Array.isArray(state.request.request_field_values)) {
      const placeholderIndex = state.request.request_field_values.findIndex(
        (field) => field.field_id === val.field_id
      )

      if (placeholderIndex !== -1) {
        state.request.request_field_values.splice(placeholderIndex, 1, val)
      } else {
        state.request.request_field_values.push(val)
      }
    }
  },
  setTimelineFiltersApplied: (state, val) => {
    state.timelineFiltersApplied = val
  }
}
